import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef, useMemo, createContext, useContext } from 'react';
import { Box } from '../Box/index.js';

/// /////////////////////////////////////////////////////////////////////
const AccordionContext = /*#__PURE__*/createContext(false);
const useAccordionContext = () => useContext(AccordionContext);
/// /////////////////////////////////////////////////////////////////////
/**
 * @deprecated Please use AccordionAlpha instead of Accordion moving forward. Accordion will be deprecated in future major releases.
 *
 * ---
 * Accordion allows users to expand one or more panels at a time, revealing information
within a small space.
 *
 * _Note_: AccordionHeader and AccordionPanels have default padding of 'lg', which can be overridden.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/accordion#usage)
 * - [Props](https://blockparty.endpoint.com/components/accordion#props)
 *  <br />
 *
 */
const Accordion = /*#__PURE__*/forwardRef((_ref, forwardedRef) => {
  let {
    children,
    openAll = false,
    ...rest
  } = _ref;
  const context = useMemo(() => ({
    openAll
  }), [openAll]);
  return /*#__PURE__*/React__default.createElement(Box, _extends({
    ref: forwardedRef
  }, rest), /*#__PURE__*/React__default.createElement(AccordionContext.Provider, {
    value: context
  }, children));
});

export { Accordion, useAccordionContext };
